import React, { memo } from 'react';
import { CONNECTION_TYPES } from './hooks/useArchitectureState';

/**
 * ArchitectureLegend Component
 *
 * Displays a legend for the connection types used in the architecture diagram.
 */
const ArchitectureLegend = memo(function ArchitectureLegend() {
  const connectionTypes = Object.values(CONNECTION_TYPES);

  return (
    <div className="arch-legend">
      <span className="arch-legend__title">Connections</span>
      <div className="arch-legend__items">
        {connectionTypes.map(type => (
          <div key={type.key} className="arch-legend__item">
            <svg
              className="arch-legend__line"
              width="40"
              height="16"
              viewBox="0 0 40 16"
            >
              {/* Arrow marker if applicable */}
              {type.hasArrow && (
                <defs>
                  <marker
                    id={`legend-arrow-${type.key}`}
                    markerWidth="8"
                    markerHeight="8"
                    refX="7"
                    refY="3"
                    orient="auto"
                    markerUnits="strokeWidth"
                  >
                    <path
                      d="M0,0 L0,6 L7,3 z"
                      fill={type.color}
                    />
                  </marker>
                </defs>
              )}
              {/* Line */}
              <line
                x1="2"
                y1="8"
                x2="30"
                y2="8"
                stroke={type.color}
                strokeWidth="2"
                strokeDasharray={type.style === 'dashed' ? '4 2' : 'none'}
                markerEnd={type.hasArrow ? `url(#legend-arrow-${type.key})` : undefined}
              />
            </svg>
            <span className="arch-legend__label">{type.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
});

export default ArchitectureLegend;
